import {Company} from '@hconnect/apiclient'

import {api} from '../App.store'
export const createCompany = async (payload: Partial<Company>) => {
  const response = await api.post<Company>('/companies', payload)
  const {data: company} = response
  return company
}
